module.exports = __webpack_public_path__ + "img/solution2.e35bc117.png";